import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedGameData} from "../server/data/WGParsedGameData";
import {WGEngineManager} from "../engine/WGEngineManager";
import {IReelSymbolStates, WGSpriteSymbol} from "../engine/Symbol/WGSpriteSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class NoWinEvent {
    public static readonly DIM_DOWN_OVERLAYS: string = "noWinEvent_dim_down_overlays"
}

export class WGNoWinPresentation extends Presentation {
    private _reels: string[][];
    private _nextMode: string = "";
    private _symWinStates: boolean[][] = [];
    private _isWarriorFeature: boolean = true;
    private _stickyWildReel: boolean[] = [];
    private _triggerWarriorSymbol: string = "";

    public checkForActivation(data: WGParsedGameData): boolean {
        return data.singleWin > 0 && (data.betWins.length > 0);
    }

    public setParsedGamedData(data: WGParsedGameData): void {
        this._reels = data.reels;
        this._nextMode = data.nextMode;
        this._symWinStates = data.symbolWinStates;
        this._isWarriorFeature = data.triggerWarriorSymbol.length > 0;
        this._stickyWildReel = data.lockedWildReelsAfter;
        this._triggerWarriorSymbol = data.triggerWarriorSymbol;
    }

    /**
     * this class will handle cases if there is bet line wins for sure
     * other symbols state handling will be done within respective feature classes
     */
    public getPresentation(): void {
        EventHandler.dispatchEvent(new GameEvent(NoWinEvent.DIM_DOWN_OVERLAYS));
        WGEngineManager.RAll((reel: number) => {
            if (this._stickyWildReel[reel]) {
                return; // do not dim symbols on sticky wild reel
            }
            if (WGEngineManager.getReel(reel).scatterSymbols.length > 0)
                WGEngineManager.getReel(reel).scatterSymbols.forEach((s) => s.changeState({state: IReelSymbolStates.NOWIN}))
            // dimming down 1 extra symbols from top and bottom
            for (let i: number = 0; i < 3; i++) {
                const sym: WGSpriteSymbol = WGEngineManager.getReel(reel).getSymbol(i)!;
                if (this._isWarriorFeature && this._triggerWarriorSymbol.indexOf(sym.symName.split("*")[0]) !== -1) {
                }
                else {
                    sym.changeState({state: IReelSymbolStates.NOWIN});
                }
            }
        });
        this.PresentationState.set(PresentationState.INACTIVE);
    }
}